import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaLinkedinIn, FaTwitter, FaFacebookF, FaInstagram, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { companyInfo } from '../../data/dummyData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'About Us', path: '/about' },
    { name: 'Our Team', path: '/team' },
    { name: 'Services', path: '/services' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Contact Us', path: '/contact' },
  ];

  const services = [
    { name: 'Legal Services', path: '/services/legal' },
    { name: 'Tax Consultation', path: '/services/tax' },
    { name: 'Training Academy', path: '/services/academy' },
  ];

  // const socialLinks = [
  //   { icon: FaLinkedinIn, href: companyInfo.social.linkedin, label: 'LinkedIn' },
  //   { icon: FaTwitter, href: companyInfo.social.twitter, label: 'Twitter' },
  //   { icon: FaFacebookF, href: companyInfo.social.facebook, label: 'Facebook' },
  //   { icon: FaInstagram, href: companyInfo.social.instagram, label: 'Instagram' },
  // ];

  return (
    <footer className="bg-gradient-to-br from-vintage-dark via-vintage-dark to-[#3a3735] text-vintage-cream relative overflow-hidden">
      {/* Decorative top wave */}

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-14   relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className='flex items-center flex-col'
            >
            <h3 className="text-3xl font-bold text-vintage-gold mb-4">
              Mission and Vision
            </h3>
            <p className="text-vintage-cream/80 mb-6 leading-relaxed text-justify">
              {companyInfo.description2}
            </p>
            {/* <div className="flex space-x-3">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <motion.a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  className="w-10 h-10 rounded-full bg-vintage-gold/10 hover:bg-vintage-gold flex items-center justify-center text-vintage-cream hover:text-white transition-all duration-300"
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  whileTap={{ scale: 0.95 }}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  >
                  <Icon className="text-lg" />
                  </motion.a>
                  );
                  })}
                  </div> */}
          </motion.div>

          {/* Quick Links */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className='flex items-center flex-col'
            >
            <h4 className="text-xl font-semibold flex flex-col items-center text-vintage-gold mb-6">Quick Links</h4>
            <ul className="space-y-3 flex flex-col items-center">
              {quickLinks.map((link) => (
                <motion.li 
                key={link.name}
                whileHover={{ x: 5 }}
                transition={{ type: "spring", stiffness: 300 }}
                >
                  <Link
                    to={link.path}
                    className="text-vintage-cream/80 hover:text-vintage-gold transition-colors flex items-center group"
                    >
                    <span className="w-1.5 h-1.5 rounded-full bg-vintage-gold mr-2 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                    {link.name}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Services */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className='flex items-center flex-col'
            >
            <h4 className="text-xl font-semibold text-vintage-gold mb-6">Our Services</h4>
            <ul className="space-y-3 flex flex-col items-center">
              {services.map((service) => (
                <motion.li 
                key={service.name}
                whileHover={{ x: 5 }}
                transition={{ type: "spring", stiffness: 300 }}
                >
                  <Link
                    to={service.path}
                    className="text-vintage-cream/80 hover:text-vintage-gold transition-colors flex items-center group"
                    >
                    <span className="w-1.5 h-1.5 rounded-full bg-vintage-gold mr-2 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                    {service.name}
                  </Link>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className='flex items-center flex-col'
          >
            <h4 className="text-xl font-semibold text-vintage-gold mb-6">Contact Us</h4>
            <ul className="space-y-4 text-vintage-cream/80">
              <li className="flex items-center align-center group">
                <div className="w-12 h-12 rounded-lg bg-vintage-gold/10 flex items-center justify-center mr-3 flex-shrink-0 group-hover:bg-vintage-gold transition-colors">
                  <FaPhone className="text-vintage-gold group-hover:text-white transition-colors" />
                </div>
                <div>
                  <p className="text-xs text-vintage-cream/60 mb-1">Phone</p>
                  <span className="text-vintage-cream">{companyInfo.contact.phone}</span><br/>
                  <span className="text-vintage-cream">{companyInfo.contact.phone2}</span>
                </div>
              </li>
              <li className="flex items-start group">
                <div className="w-12 h-12 rounded-lg bg-vintage-gold/10 flex items-center justify-center mr-3 flex-shrink-0 group-hover:bg-vintage-gold transition-colors">
                  <FaEnvelope className="text-vintage-gold group-hover:text-white transition-colors" />
                </div>
                <div>
                  <p className="text-xs text-vintage-cream/60 mb-1">Email</p>
                  <span className="text-vintage-cream break-all">{companyInfo.contact.email}</span><br/>
                  <span className="text-vintage-cream break-all">{companyInfo.contact.email2}</span>
                </div>
              </li>
              <li className="flex items-start group">
                <div className="w-12 h-12 rounded-lg bg-vintage-gold/10 flex items-center justify-center mr-3 flex-shrink-0 group-hover:bg-vintage-gold transition-colors">
                  <FaMapMarkerAlt className="text-vintage-gold group-hover:text-white transition-colors" />
                </div>
                <div>
                  <p className="text-xs text-vintage-cream/60 mb-1">Address</p>
                  <span className="text-vintage-cream">{companyInfo.contact.address}</span>
                </div>
              </li>
            </ul>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <motion.div 
          className="border-t border-vintage-gold/20 mt-12 pt-8"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <div className="text-center mb-4">
            <p className="text-vintage-cream/70 text-sm">
              &copy; {currentYear} <span className="text-vintage-gold font-semibold">Acharya Associates</span>. All rights reserved.
            </p>
          </div>
          
          {/* Designer Credit */}
          <motion.div 
            className="text-center pt-4 border-t border-vintage-gold/10"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            <p className="text-vintage-cream/60 text-xs flex items-center justify-center flex-wrap gap-1">
              <span>Designed & Developed by</span>
              <a 
                href="https://harshilmistry.vercel.app/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-vintage-gold hover:text-vintage-tan font-semibold transition-colors duration-300 inline-flex items-center group"
              >
                Harshil Mistry
                <svg 
                  className="w-3 h-3 ml-1 opacity-0 group-hover:opacity-100 transition-opacity" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" 
                  />
                </svg>
              </a>
            </p>
          </motion.div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
